import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_VALUE = 'Not set';

const FontFamilyPickerOption = ({ font }) => (
    <div className={'FontFamilyPickerOption__container'}>
        <p style={{ fontFamily: `'${font}'` }}>{font || DEFAULT_VALUE}</p>
    </div>
);

FontFamilyPickerOption.propTypes = {
    font: PropTypes.string.isRequired,
};

export default FontFamilyPickerOption;
